module.exports = __webpack_public_path__ + "img/icepellets.38250f4f.png";